import { Link } from 'react-router-dom';
import type { Media } from '@/types/media';

interface TvRankListProps {
  items: Media[];
}

export default function TvRankList({ items }: TvRankListProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {items.map((item, index) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex items-center gap-4 rounded-lg bg-background-50 p-3 ring-1 ring-background-200/70 transition-all duration-300 hover:ring-accent-300"
        >
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
              index < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
            }`}
          >
            {index + 1}
          </span>
          <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={item.cover}
              alt={`${item.title}海报`}
              title={`${item.title} - 八戒影院热播剧集`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
              {item.title}
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
              {item.genres.join(' · ')}
            </p>
            <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1 font-semibold text-accent-600">
                <i className="ri-star-fill" />
                {item.rating.toFixed(1)}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-play-circle-line" />
                {item.views}
              </span>
              <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                {item.status}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}